/*
  Authors : initappz (Rahul Jograna)
  Website : https://initappz.com/
  App Name : CryptoCurrency - CryptoApp 1 This App Template Source code is licensed as per the
  terms found in the Website https://initappz.com/license
  Copyright and Good Faith Purchasers © 2023-present initappz.
*/
export const environment = {
  production: false,
  apiBaseUrl: 'http://localhost:5026/api/',
  moralisApiKey: 'ln4U4TXytkDWFogqJszpbU83eDzA5d46tpXWyzgLncC1OfcJKNb0LMu7xfIvGB4v',
  irisApiKey: 'irs_sk_64ce644a35813f182d83c8f2b94db59f',
  lifiApiKey: '07ffb699-de63-43bb-9668-3161f5df10fc.0ffe2625-5198-471f-bd6e-2ed2a140ceca',
  uniswapApiKey: 'R-In1hvO4rWEPBkBpbnYPFWEDPQoLof0-FfY7wT6BOs',
};
